module.exports = __webpack_public_path__ + "325064dd97012d3c26b2ddd90cb45bb0.svg";